export default __webpack_public_path__ + "722febe2c91b9d4cd1c9eb7e49299a5a.png";